import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import {
    BONUS_PAGES,
} from "./constants";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {
    deleteManageBonus,
    listEmployeeSession, listManageBonus,
    saveManageBonus
} from "../../../redux/actions/settings";
import {manageBonusSelector} from "../../../redux/selectors/settings";
import ManageBonusTable from "./ManageBonusTable";
import BonusAddForm from "./BonusAddForm";




class ManageBonus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: BONUS_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            feedbackStatus: '',
            feedbackMessage: '',
            editBonus: null,
            bonus: []

        }
    }

    componentDidMount() {
        this.props.listManageBonus({locationId : this.props.user.selectedLocationId})
    }

    handleEditingClear = () => {
        this.setState({ editBonus: null }, () => {
            this.setCurrentPage(BONUS_PAGES.TABLE, {})
        })
    }

    handleEditRow = (bonus) => {
        this.setState({ editBonus: bonus }, () => {
            this.setCurrentPage(BONUS_PAGES.FORM, {})
        })
    }




    componentDidUpdate(prevProps, prevState) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText) {
            this.openFeedbackBar(this.props.status.statusText, 'error');
        }

        if (prevProps.bonus !== this.props.bonus) {
            this.setState({
                bonus: this.props.bonus,
            })
        }

    }



    displayForm = () => {
        return (
            <BonusAddForm
                user={this.props.user}
                handleEditingClear={this.handleEditingClear}
                editBonus={this.state.editBonus}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                saveBonus={this.props.saveManageBonus}
            />
        )
    }


    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayTable= () => {
        return (
            <ManageBonusTable
                handleDeleteRow={this.handleDeleteRow}
                bonus={this.props.bonus}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                handleBonusEditRow={this.handleEditRow}
            />
        )
    }

    handleDeleteRow = (deleteId) => {
        this.props.deleteManageBonus({manageBonusId: deleteId})
    }


    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case BONUS_PAGES.TABLE:
                return this.displayTable()
            case BONUS_PAGES.FORM:
                return this.displayForm()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }


    openFeedbackBar = (status, message) => {
        this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' }, () => {
            this.props.clearStatus();
        });
    }


    render() {


        return (

            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />


                {this.displayCurrentPage()}


            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    bonus: manageBonusSelector(state)
})


const actionCreators = {
    clearStatus,
    listEmployeeSession,
    saveManageBonus,
    listManageBonus,
    deleteManageBonus,
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, ManageBonus);